module.exports = __webpack_public_path__ + "img/card_icon_three.87f8620d.png";